import React from 'react';
import { ExternalLink, Edit, Trash2 } from 'lucide-react';
import CategoryBadge from './CategoryBadge';
import './ToolCard.css';

const STATUS_STYLES = {
  active: { className: 'status-active', label: 'Active' },
  evaluating: { className: 'status-evaluating', label: 'Evaluating' },
  deprecated: { className: 'status-deprecated', label: 'Deprecated' },
};

function ToolCard({ tool, canManage, showCosts, onEdit, onDelete }) {
  const statusInfo = STATUS_STYLES[tool.status] || STATUS_STYLES.active;
  const isDeprecated = tool.status === 'deprecated';

  return (
    <div className={`tool-card ${isDeprecated ? 'tool-card-deprecated' : ''}`}>
      <div className="tool-card-header">
        <div className="tool-card-title-row">
          <h3 className={`tool-card-name ${isDeprecated ? 'tool-name-deprecated' : ''}`}>
            {tool.name}
          </h3>
          <span className={`tool-status-badge ${statusInfo.className}`}>
            {statusInfo.label}
          </span>
        </div>
        <CategoryBadge name={tool.category_name} />
      </div>

      {tool.description && (
        <p className="tool-card-description">{tool.description}</p>
      )}

      <div className="tool-card-details">
        {tool.url && (
          <a
            href={tool.url}
            target="_blank"
            rel="noopener noreferrer"
            className="tool-card-url"
          >
            <ExternalLink size={14} />
            <span>{new URL(tool.url).hostname}</span>
          </a>
        )}
        {tool.managed_by && (
          <span className="tool-card-managed">Managed by: {tool.managed_by}</span>
        )}
      </div>

      {showCosts && (
        <div className="tool-card-costs">
          {tool.subscription_tier && (
            <span className="tool-card-cost-item">Tier: {tool.subscription_tier}</span>
          )}
          {tool.billing_cycle && (
            <span className="tool-card-cost-item">Billing: {tool.billing_cycle}</span>
          )}
          {tool.cost !== null && tool.cost !== undefined && (
            <span className="tool-card-cost-item">Cost: ${parseFloat(tool.cost).toFixed(2)}</span>
          )}
          {tool.renewal_date && (
            <span className="tool-card-cost-item">Renewal: {tool.renewal_date}</span>
          )}
        </div>
      )}

      {canManage && (
        <div className="tool-card-actions">
          <button className="tool-action-btn" onClick={() => onEdit(tool)} title="Edit">
            <Edit size={14} />
          </button>
          <button className="tool-action-btn tool-action-delete" onClick={() => onDelete(tool)} title="Delete">
            <Trash2 size={14} />
          </button>
        </div>
      )}
    </div>
  );
}

export default ToolCard;
